/**
 * Created by Kotkin on 27.03.17.
 */

import Module from './complaint';

export default Module;
